import moment from 'moment';

export function formatDate(date) {
    return moment(date).format('MM/DD/YYYY');
}

export function parseDate(str) {
    const m = moment(str, 'MM/DD/YYYY', true);
    return m.isValid() ? m.toDate() : undefined;
}

export function formatDollars(value, defaultValue = '$', isDashboardData = false) {
    if (!value) return defaultValue;
    if (isDashboardData) {
        const decimalPoint = value.toString().indexOf('.');
        if (decimalPoint !== -1 && value.toString().split('.')[1].length > 2) {
            return `$${commifyNumber(value.toString().slice(0, decimalPoint+3))}`
        } else {
            return `$${commifyNumber(value)}`
        }
    }
    return `$${commifyNumber(onlyNums(value))}`;
}

export function isEmptyObject(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export function trimAssetLink(assetsURL = '') {
    return assetsURL.endsWith('/') ? assetsURL.substr(0, assetsURL.length - 1) : assetsURL;
}

export function onlyNums(value) {
    const valueToString = value.toString();
    return valueToString.replace(/[^\d]/g, '');
}

export function commifyNumber(number) {
    if (number) {
        const numberString = number.toString();
        const numberArray = numberString.split('.');
        const wholeNumberString = numberArray[0];
        let newNumberString = '';
        for (let i = wholeNumberString.length; i >= 0; i--) {
            newNumberString = wholeNumberString.charAt(i) + newNumberString;
            const digitsToEnd = wholeNumberString.length - i;
            if (digitsToEnd % 3 === 0 && digitsToEnd > 0 && i > 0)
                newNumberString = ',' + newNumberString;
        }
        numberArray[0] = newNumberString;
        return numberArray.join('.');
    }
    return '';
}

export function isDefined(value) {
    return typeof value !== 'undefined';
}

export function isNullOrEmpty(string) {
    if (isDefined(string) && string.length > 0) {
        return false;
    }
    return true;
}

/**
 * transformPropValue
 *
 * Transforms Object[key].value using transform function
 *
 * @param {Object} obj
 * @param {key} key
 * @param {function} modifier
 * @returns {}
 */
export function transformPropValue(obj, key, modifier) {
    if (typeof modifier !== 'function' && !key) {
        return undefined;
    }

    if (!obj.hasOwnProperty(key)) {
        return undefined;
    }

    return modifier(obj[key]);
}

/**
 * lpadNumber
 *
 * Prepends characters of given width to number
 *
 * @param {Number} num
 * @param {Number} width
 * @param {String} char
 * @returns {String}
 */
export function lpadNumber(num = 0, width = 0, char = '0') {
    if (typeof num !== 'number') {
        return undefined;
    }
    return num.toString().length >= width
        ? num.toString()
        : new Array(width - num.toString().length + 1).join(char.toString()) + num;
}

/**
 * maxLengthNumber
 *
 * Returns number (or string) reduced to given width (left to right)
 *
 * @param {Number|String} num
 * @param {Number} Infinity
 * @returns {Number|String}
 */
export function maxLengthNumber(num, width = Infinity) {
    if (!num) {
        return undefined;
    }
    const numLength = num.toString().length;
    if (numLength <= width) {
        return num;
    }
    const result = num.toString().substr(0, numLength - (numLength - width));
    if (typeof num === 'number') {
        return parseInt(result, 10);
    }
    return result;
}

export function hashStr(str = '') {
    var hash = 0;
    if (typeof str !== 'string' || str.length === 0) {
        return hash;
    }
    for (let i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = hash & hash;
    }
    return hash;
}

/**
 * Detemines if provided userAgent is IE of any version: >11, 11, EDGE
 *
 * Per https://codepen.io/gapcode/pen/vEJNZN
 *
 * @param {string} window.navigator.userAgent
 *
 * @returns {boolean} true if is IE otherwise false
 */
export const isBrowserIE = (userAgent) => {
    const msie = userAgent.indexOf('MSIE ');
    if (msie > 0) { // IE 10 or older
        return true
    }

    const trident = userAgent.indexOf('Trident/');
    if (trident > 0) { // IE 11
        return true
    }

    const edge = userAgent.indexOf('Edge/');
    if (edge > 0) { // Edge (IE 12+)
        return true;
    }

    return false; // other browser
}

/**
 * Convert In Blob to array
 *
 * @param {string} base64 String
 *
 * @returns {bytes}  array
 */
export const base64ToArrayBuffer = (base64) => {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        const ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}

/**
 * Generate Link and Download
 *
 * @param {bytes} array
 *
 * @returns file
 */
export const saveByteArray = (data, name, type = "octet/stream") => {
    const blob = new Blob([data], { type })
    if (window.navigator.msSaveBlob) { // // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
        window.navigator.msSaveOrOpenBlob(blob, name);
    } else {
        const downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);
        downloadLink.style = "display: none"
        const url = window.URL.createObjectURL(blob)
        downloadLink.href = url;
        downloadLink.download = name;
        downloadLink.click();
        window.URL.revokeObjectURL(url);
    }
};

export const saveByteArray_getUrl = (data, name, type = "octet/stream") => {
    const blob = new Blob([data], { type })
    if (window.navigator.msSaveBlob) { // // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
        window.navigator.msSaveOrOpenBlob(blob, name);
    } else {
        const downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);
        downloadLink.style = "display: none"
        const url = window.URL.createObjectURL(blob)
        downloadLink.href = url;
        downloadLink.download = name;
        return url;
    }
};
